import React from 'react';
import BusinessesSection from '../../../sections/AdminDashboard/UserManagement/Businesses';

const Businesses = () => {
  return <BusinessesSection />;
};

export default Businesses;

